import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzHlwn65 } from './pages'

type TIdToPageMapWoofzHlwn65 = Record<PageIdWoofzHlwn65, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_HLWN_65: TIdToPageMapWoofzHlwn65 = {
  [PageId.SUBSCRIPTIONS_PAGE_HLWN_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_65/pages/subscriptions/SubscriptionHlwn65'
      ).then((m) => ({
        default: m.SubscriptionsHlwn65,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_65/pages/subscriptions/SubscriptionHlwn65'
      ),
  },
  [PageId.CHAT_UPSELL_HLWN_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_65/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_65/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_HLWN_65]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_hlwn/woofz_hlwn_65/pages/upsell/Upsell').then(
        (m) => ({
          default: m.Upsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_hlwn/woofz_hlwn_65/pages/upsell/Upsell'),
  },
  [PageIdWoofzHlwn65.DOWNLOAD_HLWN_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_65/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_65/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzHlwn65.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
